import React from 'react'
import { ReactComponent as LogoSvg } from './logo.svg'
import styled from 'styled-components'

const Logo: React.FC = () => {
  return <TaglineLogo />
}

const TaglineLogo = styled(LogoSvg)`
  width: 104px;
  fill: #1c658e;
  @media screen and (max-width: 856px) {
    width: 52px;
  }
`

export default Logo
